import styled from "styled-components";

export const StyledError = styled.div`
    text-align: left;
    color: ${(props) => props.theme.colors.red};
    line-height: 20px;
    font-weight: bold;
    font-size: 12px;
`;